import React, { useState } from 'react';
import styled from 'styled-components';

import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import {
  useTextCallbackThrottle,
  useUpdateValueAfterFirstRender,
} from '#/components/hooks';

const Wrapper = styled.div<{ $width: string }>`
  width: ${props => props.$width};
  height: 40px;
  overflow: hidden;
  transition: 0.7s ease width;

  display: inline-flex;
  align-items: center;
  justify-content: space-between;

  border: 1px solid #515158;
  border-radius: 5px;
  padding-right: 7px;
`;

const SearchIconStyled = styled(MaterialSymbol)`
  opacity: 1;
`;

const Input = styled.input`
  width: 100%;
  height: 30px;

  text-align: left;

  border: none;
  padding: 0;
  padding-left: 5px;
  padding-right: 5px;
  color: white;
  background: none;
  outline: none;

  &:disabled {
    cursor: not-allowed;
  }
`;

type SharedProps = {
  placeholder?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  appearAnimation?: boolean;
  autoFocusDisabled?: boolean;
};

type Props = SharedProps & {
  value: string;
};

export default function SearchInput({
  appearAnimation,
  value,
  onChange,
  onBlur,
  placeholder,
  autoFocusDisabled,
}: Props) {
  const wrapperWidth = useUpdateValueAfterFirstRender('35px', '200px', {
    ignoreInitial: !appearAnimation,
  });
  return (
    <Wrapper $width={wrapperWidth}>
      <Input
        autoFocus={!autoFocusDisabled}
        type="text"
        placeholder={placeholder || 'Search'}
        value={value}
        onChange={event => onChange(event.target.value)}
        onBlur={onBlur}
        spellCheck={false}
      />
      <SearchIconStyled icon="search" fontSize="small" color="#323232" />
    </Wrapper>
  );
}

type PropsThrottled = SharedProps & {
  defaultValue?: string;
  throttleDelayMs: number;
};

export function SearchUncontrolledInput(props: PropsThrottled) {
  const [searchInstantText, setSearchInstantText] = useState(
    props.defaultValue || ''
  );

  // Throttle calling parent callback for slick fast text typing experience
  useTextCallbackThrottle(
    searchInstantText,
    props.onChange,
    props.throttleDelayMs
  );

  return (
    <SearchInput
      {...props}
      value={searchInstantText}
      onChange={setSearchInstantText}
    />
  );
}
